import { defineComponent } from '../engine/ecs';
import type { Direction } from '../render/spriteFactory';

/** Componenti dati puri condivisi dai sistemi di gioco. */

export interface PositionData {
  x: number;
  y: number;
}

export interface VelocityData {
  vx: number;
  vy: number;
  speed: number; // px/s
}

export interface FacingData {
  dir: Direction;
  walking: boolean;
}

export interface ColliderData {
  // AABB centrata su Position.x, ancorata ai piedi (Position.y = base)
  width: number;
  height: number;
}

export interface PlayerControlledData {
  /** Distanza percorsa su tile a incontri dall'ultimo check (in px). */
  encounterMeter: number;
}

export const Position = defineComponent<PositionData>('position');
export const Velocity = defineComponent<VelocityData>('velocity');
export const Facing = defineComponent<FacingData>('facing');
export const Collider = defineComponent<ColliderData>('collider');
export const PlayerControlled = defineComponent<PlayerControlledData>('playerControlled');
